<template>
    <FormItem prop="company" ref="company">
        <template slot="label">
            <span>Customer</span>
            <small v-if="value && value._uuid && $store.getters.hasAccess('company', 'create')"
                   style="color:red">
                <template>[ will be created ]</template>
            </small>
        </template>

        <Select :value="value ? value.id : null"
                filterable
                size="large"
                remote
                :loading="loading"
                @on-change="onChange"
                @on-query-change="onQueryChange">
            <Option v-for="item in options"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id">
                <template>{{item.name}}</template>
            </Option>
        </Select>
    </FormItem>
</template>

<script>
  import uuid from '../utils/uuid'
  import {Company} from '../models/Company'

  export default {
    props: {
      value: {
        type: Object,
      }
    },

    data() {
      return {
        loading: false,
        list: [],
        options: [],
      }
    },

    methods: {
      async reload() {
        let response = await new Company().all();

        this.options = this.list = response.data || [];
        if (this.value && this.findById(this.value.id).length === 0) {
          this.options = [this.value, ...this.options]
        }
      },

      findById(id) {
        return this.list.filter(item => item.id === id)
      },

      onChange(id) {
        if (this.value && id !== this.value.id && !this.value._uuid) {
          let filtered = this.findById(id);
          this.$emit('input', filtered.length ? filtered[0] : null)
        }
      },

      onQueryChange(value) {
        let uniq = uuid();
        this.loading = true;

        if (value) {
          let company = {id: uniq, name: value, _uuid: uniq};

          this.options = this.list.filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);

          let filtered = this.list.filter(item => item.name.toLowerCase() === value.toLowerCase());

          if (filtered.length === 0) {
            this.options = [company, ...this.options];
            this.$emit('input', company)
          } else {
            this.$emit('input', filtered[0])
          }
        } else {
          this.options = this.list;
        }
        this.loading = false;
        this.$refs.company.validate()
      },
    },

    mounted() {
      this.reload()
    },
  }
</script>
